import { treaty } from '@elysiajs/eden';

import type { BackendAppType } from '../../backend/src/backend-types';
import { config } from './config';

export const TOKEN_KEY = 'disit_jwt_token';

function dynamicHeaders(): Record<string, string> {
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export const apiOrigin = config.API_URL;
const client = treaty<BackendAppType>(apiOrigin, { headers: dynamicHeaders });

class ApiClient {
  api = client;

  setToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
  }

  clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  }

  get tokenPresent() {
    return Boolean(localStorage.getItem(TOKEN_KEY));
  }

  get authorizationHeaders() {
    return dynamicHeaders();
  }
}

export const api = new ApiClient();
